import React from "react";

const Loader = () => {
  return (
    <tbody>
      <tr className="noData">
        <td className="inner">
          <div className="loader_container">
            <div className="lds-ellipsis">
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default Loader;
